class SessionStorage {
  constructor() {
    this.storage = undefined;

    try {
      const checkKey = "delete-me-please";
      const checkValue = "123";
      sessionStorage.setItem(checkKey, checkValue);
      if (sessionStorage.getItem(checkKey) !== checkValue) {
        throw new Error("getItem did not return correct check value");
      }
      sessionStorage.removeItem(checkKey);
    } catch (err) {
      this.storage = {};
      console.error("Error when trying to access sessionStorage:", err);
    }
  }

  removeItem(key) {
    if (this.storage) {
      delete this.storage[key];
      return key;
    }
    return sessionStorage.removeItem(key);
  }

  setItem(key, item) {
    if (this.storage) {
      this.storage[key] = item;
      return item;
    }
    return sessionStorage.setItem(key, item);
  }

  getItem(key) {
    if (this.storage) {
      return this.storage[key];
    }
    return sessionStorage.getItem(key);
  }
}

export default new SessionStorage();
